import Image from 'next/image';
import { useState } from 'react';

import { LiteYouTubeProps } from './LiteYouTube.props';

const getDefaultPosterUrl = (videoId: string): string =>
  `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/hqdefault.jpg`;

export const LiteYouTube = ({
  videoId,
  title,
  playLabel,
  posterUrl,
  posterAlt,
}: LiteYouTubeProps) => {
  const [isActivated, setIsActivated] = useState<boolean>(false);
  const encodedVideoId = encodeURIComponent(videoId);

  if (isActivated) {
    return (
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${encodedVideoId}?autoplay=1&playsinline=1&rel=0`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        className="absolute inset-0 h-full w-full border-0"
      />
    );
  }

  return (
    <button
      type="button"
      className="group relative h-full w-full cursor-pointer overflow-hidden rounded bg-primaryLight"
      aria-label={playLabel}
      onClick={() => setIsActivated(true)}
    >
      <Image
        src={posterUrl || getDefaultPosterUrl(videoId)}
        alt={posterAlt || title}
        fill
        sizes="(min-width: 768px) 50vw, 100vw"
        className="object-cover transition-transform duration-300 group-hover:scale-105"
      />
      <span className="absolute inset-0 bg-primaryDark/20 transition-colors duration-300 group-hover:bg-primaryDark/30" />
      <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-accentMain text-white shadow-base transition-colors duration-300 group-hover:bg-accentAdditional">
        <span className="ml-1 block h-0 w-0 border-y-[14px] border-l-[22px] border-y-transparent border-l-white" />
      </span>
    </button>
  );
};
